<template>
    <view />
</template>


<script>
import SuperAppComponentCore from "@sa-platform/sa-p-component-core";
import view from "./sac-t-kodinpro-guestmain/sac-t-kodinpro-guestmain";

import axios from "axios";

export default {

    extends: SuperAppComponentCore,
    components: {
        view
    },
    data() {
        return {

        };
    },
    methods:
    {

    }
};
</script>
